export const BRAND_ASSETS = {
  logoWithHorizontalTitle:
    "https://faradars.org/wp-content/uploads/2025/05/28/logo-with-horizantal-title-.svg",
  footerLogo:
    "https://faradars.org/wp-content/uploads/2025/05/28/footerlogo.svg",
  headerLogo:
    "https://faradars.org/wp-content/uploads/2025/05/28/headerlogo.svg",
  logoWithVerticalTitle:
    "https://faradars.org/wp-content/uploads/2025/05/28/logo-with-vertical-title.svg",
  whiteLogo: "https://faradars.org/wp-content/uploads/2025/05/31/whitelogo.svg",

  brandLogo:
    "https://faradars.org/wp-content/uploads/2025/06/10/68480959526a1-fav-square.png",
  mainPageLogo:
    "https://faradars.org/wp-content/uploads/2025/05/31/mainpagelogo.png",
  whiteLogoWithoutTitle:
    "https://faradars.org/wp-content/uploads/2025/06/02/whitelogowithouttitle.svg",
};
